export const QuestionActionTypes={
    SET_FETCHED_QUESTIONS_TO_STATE_CIRCUITRON:'SET_FETCHED_QUESTIONS_TO_STATE_CIRCUITRON',
    SET_SELECTED_QUESTION_CIRCUITRON:'SET_SELECTED_QUESTION_CIRCUITRON',
    SELECTED_QUESTION_NEXT_CIRCUITRON:'SELECTED_QUESTION_NEXT_CIRCUITRON',
    SELECTED_QUESTION_PREVIOUS_CIRCUITRON:'SELECTED_QUESTION_PREVIOUS_CIRCUITRON',
    SET_SELECTED_ANSWER_CIRCUITRON:'SET_SELECTED_ANSWER_CIRCUITRON',
    // SET_RECENT_FETCHED_TIME:"SET_RECENT_FETCHED_TIME"
}